import type { ReactNode } from "react";
import { Drawer } from "cerulean";

interface WireTemplateDrawerProps {
  isOpen: boolean;
  onDismiss: () => void;
  children: ReactNode;
}

/**
 * Shared drawer shell for wire template create/edit flows.
 * Renders a slide-out Drawer with no built-in controls.
 * The caller provides form content as children and controls
 * open/dismiss behavior via props.
 *
 * Reusable for both international and domestic wire templates.
 */
const WireTemplateDrawer = ({
  isOpen,
  onDismiss,
  children,
}: WireTemplateDrawerProps) => (
  <Drawer
    isOpen={isOpen}
    paddingSize="none"
    onUserDismiss={onDismiss}
    showControls={false}
    depth="633px"
  >
    {children}
  </Drawer>
);

export default WireTemplateDrawer;
